import Vue from 'vue';
import VeeValidate from 'vee-validate';

Vue.use(VeeValidate, {
    fieldsBagName: 'vFields',
    dictionary: {
        en: {
            custom: {
                firstName: {
                    required: 'The first name field is required.'
                },
                lastName: {
                    required: () => 'The last name field is required.'
                }
            }
        }
    }
});

Vue.config.performance = true;

window.app = new Vue({
    el: '#contactUsApp',
    data: {
        firstName:"",
        lastName: "",
        phone: "",
        message: "",
        email: ""
    },
    methods: {
        checkForm(event) {
            this.$validator.validate().then(valid => {
                if (valid) {
                    this.$refs.form.submit();
                }
            });

            if (event) event.preventDefault();
        }
    }
});

